import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';

const routes: Routes = [
  {
    path: '',
    component: DateTimePickerPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [DateTimePickerPage]
})
export class DateTimePickerPageModule {}
